import { ParametrosCaneta } from "./UserData";
import { RangeIntervalo } from "./range.intervalo";
import { EnumTipoIntervalo } from "../enums/EnumTipoIntervalo";
import { EnumTipoSelecao } from "../enums/EnumTipoSelecao";

export class Intervalo {
  public idOrigem: string;
  public ranges: RangeIntervalo[];
  public tipoIntervalo: EnumTipoIntervalo;
  public tipoSelecao: EnumTipoSelecao;
  public destacar: boolean;
  public dataAlteracao: Date;

  public constructor(
    idOrigem: string,
    tipoIntervalo: EnumTipoIntervalo,
    destacar: boolean,
    de: number,
    ate: number,
    dataAlteracao: Date,
    tipoSelecao: EnumTipoSelecao = null
  ) {
    this.idOrigem = idOrigem;
    this.tipoIntervalo = tipoIntervalo;
    this.destacar = destacar;
    this.tipoSelecao = tipoSelecao;
    this.dataAlteracao = dataAlteracao;

    this.ranges = new Array<RangeIntervalo>();
    const range = new RangeIntervalo();
    range.de = de;
    range.ate = ate;
    range.ignorar = false;

    this.ranges.push(range);
  }

  public getTextDecoration(p: ParametrosCaneta): string {
    if (
      (!this.destacar &&
        (this.tipoIntervalo === EnumTipoIntervalo.MarcacaoProva ||
          this.tipoIntervalo === EnumTipoIntervalo.Comentario ||
          this.tipoIntervalo === EnumTipoIntervalo.Mnemonico)) ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta1 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta2 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta3 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta4 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta5
    ) {
      let cor: string;
      switch (this.tipoIntervalo) {
        case EnumTipoIntervalo.MarcacaoProva:
          cor = p.corTagProva;
          break;
        case EnumTipoIntervalo.Comentario:
          cor = p.corTagComentario;
          break;
        case EnumTipoIntervalo.Mnemonico:
          cor = p.corTagMnemonico;
          break;
        case EnumTipoIntervalo.Caneta1:
          cor =
            p.corCaneta1.indexOf("rgb") > -1
              ? this.rgbToHex(p.corCaneta1)
              : p.corCaneta1;
          break;
        case EnumTipoIntervalo.Caneta2:
          cor =
            p.corCaneta2.indexOf("rgb") > -1
              ? this.rgbToHex(p.corCaneta2)
              : p.corCaneta2;
          break;
        case EnumTipoIntervalo.Caneta3:
          cor =
            p.corCaneta3.indexOf("rgb") > -1
              ? this.rgbToHex(p.corCaneta3)
              : p.corCaneta3;
          break;
        case EnumTipoIntervalo.Caneta4:
          cor =
            p.corCaneta4.indexOf("rgb") > -1
              ? this.rgbToHex(p.corCaneta4)
              : p.corCaneta4;
          break;
        case EnumTipoIntervalo.Caneta5:
          cor =
            p.corCaneta5.indexOf("rgb") > -1
              ? this.rgbToHex(p.corCaneta5)
              : p.corCaneta5;
          break;
      }
      return `underline ${cor}`;
    }

    return null;
  }

  public getBackgroundColor(p: ParametrosCaneta): string {
    let cor = null;

    if (
      this.tipoIntervalo === EnumTipoIntervalo.Caneta1 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta2 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta3 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta4 ||
      this.tipoIntervalo === EnumTipoIntervalo.Caneta5
    ) {
      switch (this.tipoSelecao) {
        case EnumTipoSelecao.Caneta1:
          cor = p.corCaneta1;
          break;
        case EnumTipoSelecao.Caneta2:
          cor = p.corCaneta2;
          break;
        case EnumTipoSelecao.Caneta3:
          cor = p.corCaneta3;
          break;
        case EnumTipoSelecao.Caneta4:
          cor = p.corCaneta4;
          break;
        case EnumTipoSelecao.Caneta5:
          cor = p.corCaneta5;
          break;
      }
    } else if (this.tipoIntervalo === EnumTipoIntervalo.ResultadoBusca) {
      cor = this.destacar
        ? ParametrosCaneta.corResultadoBuscaDestaque
        : ParametrosCaneta.corResultadoBuscaNormal;
    } else {
      cor = this.destacar ? ParametrosCaneta.corDestaqueHover : null;
    }

    return cor;
  }

  public getModoRealce(p: ParametrosCaneta): string {
    let modo = null;

    switch (this.tipoSelecao) {
      case EnumTipoSelecao.Caneta1:
        modo = p.modoRealceCaneta1;
        break;
      case EnumTipoSelecao.Caneta2:
        modo = p.modoRealceCaneta2;
        break;
      case EnumTipoSelecao.Caneta3:
        modo = p.modoRealceCaneta3;
        break;
      case EnumTipoSelecao.Caneta4:
        modo = p.modoRealceCaneta4;
        break;
      case EnumTipoSelecao.Caneta5:
        modo = p.modoRealceCaneta5;
        break;
    }
    return modo;
  }

  public rgbToHex(color) {
    color = "" + color;
    if (!color || color.indexOf("rgb") < 0) {
      return;
    }

    if (color.charAt(0) === "#") {
      return color;
    }

    const nums = /(.*?)rgb\((\d+),\s*(\d+),\s*(\d+)\)/i.exec(color),
      r = parseInt(nums[2], 10).toString(16),
      g = parseInt(nums[3], 10).toString(16),
      b = parseInt(nums[4], 10).toString(16);

    return (
      "#" +
      ((r.length === 1 ? "0" + r : r) +
        (g.length === 1 ? "0" + g : g) +
        (b.length === 1 ? "0" + b : b))
    );
  }
}
